import React from 'react';

import { HStack } from '@chakra-ui/react';

import { Tag } from '@/components/core';

import {
  GLOBAL_SEARCH_FILTERS,
  GlobalSearchFilter,
  GlobalSearchFilterId,
} from './filters';

export type { GlobalSearchFilter, GlobalSearchFilterId };

interface SearchFilterPillsProps {
  selectedId: GlobalSearchFilterId;
  onSelect: (filter: GlobalSearchFilter) => void;
}

export const SearchFilterPills: React.FC<SearchFilterPillsProps> = ({
  selectedId,
  onSelect,
}) => {
  return (
    <HStack
      gap={1}
      overflowX='auto'
      w='full'
      css={{
        '&::-webkit-scrollbar': { display: 'none' },
        scrollbarWidth: 'none',
      }}
      data-cy='global-search-filters'
    >
      {GLOBAL_SEARCH_FILTERS.filter(filter => !filter.isPlaceholder).map(
        filter => (
          <Tag
            key={filter.id}
            size='sm'
            flexShrink={0}
            isSelected={selectedId === filter.id}
            onClick={() => onSelect(filter)}
            fontWeight='normal'
            data-cy={`global-search-filter-${filter.id}`}
          >
            {filter.label}
          </Tag>
        )
      )}
    </HStack>
  );
};
